import { Flame, Leaf } from "lucide-react";

// Small dietary indicators shown next to each menu item.
export function DietBadges({ tags = [] }) {
  const isVeg = tags.includes("veg");
  const isNonVeg = tags.includes("nonveg");
  const isVegan = tags.includes("vegan");
  const isSpicy = tags.includes("spicy");

  return (
    <span className="inline-flex items-center gap-1.5 align-middle" data-testid="diet-badges">
      {isVeg && (
        <span title="Vegetarian" aria-label="Vegetarian"
          className="w-4 h-4 grid place-items-center border-2 border-emerald-500 rounded-[4px]">
          <span className="w-2 h-2 rounded-full bg-emerald-500" />
        </span>
      )}
      {isNonVeg && (
        <span title="Non-Vegetarian" aria-label="Non-Vegetarian"
          className="w-4 h-4 grid place-items-center border-2 border-red-500 rounded-[4px]">
          <span className="w-2 h-2 rounded-full bg-red-500" />
        </span>
      )}
      {isVegan && (
        <span title="Vegan" aria-label="Vegan"
          className="inline-flex items-center gap-0.5 text-emerald-400">
          <Leaf size={15} strokeWidth={2.4} />
        </span>
      )}
      {isSpicy && (
        <span title="Spicy" aria-label="Spicy" className="text-orange-500">
          <Flame size={15} strokeWidth={2.4} className="fill-orange-500/30" />
        </span>
      )}
    </span>
  );
}

// The legend explaining the symbols (senior & first-timer friendly).
export function DietLegend() {
  return (
    <div data-testid="diet-legend" className="flex flex-wrap items-center justify-center gap-x-7 gap-y-3 text-neutral-300 text-base">
      <span className="flex items-center gap-2">
        <span className="w-4 h-4 grid place-items-center border-2 border-emerald-500 rounded-[4px]"><span className="w-2 h-2 rounded-full bg-emerald-500" /></span>
        Vegetarian
      </span>
      <span className="flex items-center gap-2">
        <span className="w-4 h-4 grid place-items-center border-2 border-red-500 rounded-[4px]"><span className="w-2 h-2 rounded-full bg-red-500" /></span>
        Non-Vegetarian
      </span>
      <span className="flex items-center gap-2 text-emerald-400"><Leaf size={16} strokeWidth={2.4} /> <span className="text-neutral-300">Vegan</span></span>
      <span className="flex items-center gap-2 text-orange-500"><Flame size={16} strokeWidth={2.4} /> <span className="text-neutral-300">Spicy</span></span>
    </div>
  );
}
